const profileDetails = {
  name: "Mithun Kodoth",
  location: "Abu Dhabi, UAE",
  website: "https://mithun.kodothgroup.com",
  email: "mithunpm809@gmail.com",
  phone: "+971 50 7717522",
};

const profile = {
  theme: "dark",
  projectTitle: profileDetails.name,
  specialty: ["scalable", "efficient", "user-centric solutions"],
  journey: ["innovation", "leadership"],
  keyAnalyze: [
    "Software Architect",
    "Full Stack Developer",
    "Open Source Enthusiast",
    "I build scalable web applications and contribute to the open source community",
  ],
  name: profileDetails.name,
  description: "",
  contact: profileDetails,
  aboutSection: {
    position: "focused product designer",
    description: [
      "I am a seasoned Technology Lead with a proven track record of delivering innovative solutions and leading high-performing teams. With over six years of experience across global organizations like Techcarrot, Xoxoday, and Bussr, I have consistently driven success in diverse domains such as Automobile, Manufacturing, Real-Estate, Finance, and more. My expertise lies in leveraging cutting-edge technologies to solve complex problems and create impactful digital experiences.",
      "I specialize in AI/ML, full-stack development, cloud computing, and software architecture. My technical toolkit includes advanced frameworks like ReactJS, NodeJS, and NestJS, as well as cloud platforms such as Azure and AWS. I am adept at implementing secure, scalable, and efficient solutions, ensuring the highest standards of quality and performance.",
      "I hold a Master's degree from Catholic University of Murcia and a Bachelor's degree from Kannur University. My passion for technology and innovation drives me to stay ahead of emerging trends, including AI, IoT, and cloud computing. I am committed to delivering excellence and making a meaningful impact in every project I undertake.",
    ],
  },
  socialLinks: [
    {
      icon: "In",
      name: "LinkedIn",
      href: "https://in.linkedin.com/in/mithun-p-madhav",
      color: "hover:text-blue-500",
    },
    {
      icon: "G",
      name: "Github",
      href: "https://github.com/mithunmadhavan/",
      color: "hover:text-blue-400",
    },
  ],
  experiences: [
    {
      year: "Present",
      title: "Software Engineer - Lead",
      company: "Etihad Airways Group",
      isActive: true,
      delay: 200,
    },
    {
      year: "2022",
      title: "Senior Software Engineer III",
      company: "NReach Online Services Pvt Ltd",
      isActive: false,
      delay: 400,
    },
    {
      year: "2021",
      title: "Senior Software Engineer III - (Full Stack)",
      company: "Bussr Pte Ltd",
      isActive: false,
      delay: 600,
    },
    {
      year: "2019",
      title: "Lead Software Engineer",
      company: "Asokaa Developers Pvt. Ltd",
      isActive: false,
      delay: 800,
    },
    {
      year: "2017",
      title: "Software Engineer",
      company: "Sysin Technologies",
      isActive: false,
      delay: 1000,
    },
    {
      year: "2016",
      title: null,
      company: null,
      isActive: false,
      delay: 1000,
    },
  ],
  servicesProvided: [
    {
      title: "Full Stack Development",
      description:
        "Design and implement scalable solutions using NodeJS, ReactJS, and TypeScript, focusing on efficiency and maintainability.",
      delay: 200,
    },
    {
      title: "DevOps & Cloud Management",
      description:
        "Adopt DevOps practices and manage cloud servers in Azure, ensuring high availability and robust system operations.",
      delay: 400,
    },
    {
      title: "Team Leadership",
      description:
        "Lead teams, conduct code reviews, and align deliverables with project milestones while managing on-shore and off-shore teams.",
      delay: 600,
      highlight: true,
    },
    {
      title: "API Development & Integration",
      description:
        "Engineer robust APIs and implement advanced queuing mechanisms with Kafka for efficient data processing and system communication.",
      delay: 800,
    },
  ],
  expertise: [
    {
      title: "Full Stack Development",
      description:
        "Architect and implement scalable solutions using NodeJS, ReactJS, and TypeScript. Expertise in building monolithic, microservice, and hybrid architectures.",
    },
    {
      title: "DevOps & Cloud Management",
      description:
        "Adopt DevOps practices and manage cloud servers in Azure, ensuring high availability and robust system operations.",
    },
    {
      title: "Team Leadership",
      description:
        "Lead teams of up to 12 members, conduct code reviews, and align deliverables with project milestones while managing on-shore and off-shore teams.",
    },
    {
      title: "API Development",
      description:
        "Engineer robust APIs using NodeJS and implement advanced queuing mechanisms with Kafka for efficient data processing.",
    },
    {
      title: "UI/UX Design",
      description:
        "Design and develop user-friendly interfaces with ReactJS, focusing on custom components and hooks for better user engagement.",
    },
    {
      title: "Database Optimization",
      description:
        "Optimize database interactions using PostgreSQL, MongoDB, and Redis for enhanced system efficiency and faster response times.",
    },
  ],
};

export default profile;
